import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-351b67d7"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "toast-container" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomToaster',
    props: {
        title: {},
        message: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", null, _toDisplayString(props.title), 1),
                _createElementVNode("p", null, _toDisplayString(props.message), 1)
            ]));
        };
    }
});
